import React, { useEffect, useState, useContext } from 'react'
import LocaleContext from '../../contexts/localeContext'
import { navigate } from 'gatsby'
import { useProductSlug } from '../../hooks/slugs/useProductSlug'
import { useNavigationHome } from '../../hooks/useNavigationHome'
import { useProductI18n } from '../../hooks/i18n/useProductI18n'
import { getPriceForListerPage } from '../../services/backendApiService'
import { v4 as uuid } from 'uuid'
import { logException } from '../../services/loggingService'
import { AccountTypeCredit, isAnonymousUser } from '../../services/userService'
import UserContext from '../../contexts/userContext'
import GeolocationContext from '../../contexts/geolocationContext'
import { useCountries } from '../../hooks/useCountries'
import { useProductPriceI18n } from '../../hooks/i18n/useProductPriceI18n'
import { useProductStockI18n } from '../../hooks/i18n/useProductStockI18n'
import { getStockLevelString } from '../../services/stockLevelService'
import { Spinner } from 'react-bootstrap'
import { calculateDaysToDespatch } from '../../services/dateService'
import { makePartNumberUrlSafe } from '../../services/urlService'
import { getI18nText } from '../../services/i18nService'
import { StockLevel } from './stockLevel'
import { GetCurrencyForCountry } from '../../services/currencyService'
import LanguageContext from '../../contexts/languageContext'
import { DisplayPriceAsString } from './displayPrice'
import { buildProductClickEvent, publishProductClickEvent } from '../../services/dataLayerService'
import BasketContext from '../../contexts/basketContext'
import DataLayerContext from '../../contexts/dataLayerContext'

const SearchResult = ({ item, displayFields }) => {
  const [isProduct, setIsProduct] = useState(isProductItem(item))

  useEffect(() => {
    setIsProduct(isProductItem(item))
  }, [item])

  return (
    <>
      {isProduct ? (
        <ProductSearchResultItem item={item} displayFields={displayFields} />
      ) : (
        <DatasheetSearchResultItem item={item} displayFields={displayFields} />
      )}
    </>
  )
}

export default SearchResult

function findTranslation(key, displayFields) {
  for (let i = 0; i < displayFields.field.length; i++) {
    if (displayFields.field[i].skey === key) {
      return displayFields.field[i].name
    }
  }

  return `<${key}>`
}

function isProductItem(item) {
  if (item.link !== null && item.link.length > 0) {
    if (item.link[0]['url-params'].indexOf('rootnorgren_datasheets') !== -1) {
      return false
    }
  }

  return true
}

export const ProductSearchResultItem = ({ item, displayFields }) => {
  const { eventApi } = useContext(DataLayerContext)
  const locale = useContext(LocaleContext)
  const { email, queryingUser, accountNumber, isDistributor } = useContext(UserContext)
  const { country } = useContext(GeolocationContext)
  const { language } = useContext(LanguageContext)
  const { basketCurrency } = useContext(BasketContext)
  const countries = useCountries(locale)
  const [boxQuantity, setBoxQuantity] = useState()
  const [currency, setCurrency] = useState()
  const [stockLevelIndicator, setStockLevelIndicator] = useState()
  const [price, setPrice] = useState()
  const [loginForPrice, setLoginForPrice] = useState()
  const [loading, setLoading] = useState(true)
  const [leadTime, setLeadTime] = useState()
  const [quantity] = useState(1)
  const [stockOnHand, setStockOnHand] = useState()
  const [quoteOnly, setQuoteOnly] = useState()
  const productMicrocopy = useProductI18n(locale)
  const [description, setDescription] = useState()
  const [imageUrl, setImageUrl] = useState()
  const [productCode, setProductCode] = useState()
  const [datasheetLink, setDatasheetLink] = useState()
  const [cadLink, setCadLink] = useState()
  const [otherAttributes, setOtherAttributes] = useState([])
  const [isRangeSKU, setIsRangeSKU] = useState()
  const [productSlug, setProductSlug] = useState()
  const [eventModelToPublish, setEventModelToPublish] = useState()

  const navHome = useNavigationHome(locale).slug
  const navProduct = useProductSlug(locale)

  useEffect(() => {
    function getTheProduct(partNumber, currency) {
      if (isRangeSKU !== 'True') {
        let requestId = uuid()
        setLoading(true)
        if (partNumber !== undefined && partNumber !== null) {
          getPriceForListerPage(partNumber, country, currency, language, requestId)
            .then((data) => {
              if (data && data.product) {
                setBoxQuantity(data.product.boxQuantity)
                setStockLevelIndicator(data.product.stockLevelIndicator)

                setLeadTime(data.product.leadTime)
                setStockOnHand(data.product.stockAmount)
                setLoginForPrice(data.loginForPricingFeature)
                setQuoteOnly(data.product.quoteOnly)
                if (data.product.price) {
                  setPrice(data.product.price.amount)
                  setCurrency(data.product.price.currency)
                }
              } else {
                setBoxQuantity(1)
                setStockLevelIndicator(null)
                setQuoteOnly(true)
              }
              setLoading(false)
            })
            .catch((error) => {
              logException('Search result error', error)
              setStockLevelIndicator(null)
              setQuoteOnly(true)
              setLoading(false)
            })
        }
      }
    }

    let myCadenasCataloguePath = undefined
    let myVarSet = undefined
    let myProductCode = undefined
    let myOtherAttributes = []
    for (let index = 0; index < item.attribute.length; index++) {
      const element = item.attribute[index]
      switch (element.name) {
        case '_imageurl':
          setImageUrl(
            element.value[0].value.replace(
              'http://d25g25bk48as5o.cloudfront.net/',
              'https://cdn.norgren.com/'
            )
          )
          break
        case 'description':
          const myDescription = element.value[0].value
          if (myDescription) {
            import('he').then((he) => {
              if (myDescription) {
                setDescription(he.decode(myDescription))
              }
            })
          }
          break
        case 'productid':
          setProductCode(element.value[0].value)
          myProductCode = element.value[0].value
          break
        case 'technical_specs':
          setDatasheetLink('https://cdn.norgren.com/pdf/' + element.value[0].value)
          break
        case 'cadenas_catalogue_path':
          myCadenasCataloguePath = element.value[0].value
          break
        case 'varset':
          myVarSet = element.value[0].value
          break
        case 'israngesku':
          setIsRangeSKU(element.value[0].value)
          break

        case 'k_indicator_europe':
        case 'stock_indicator_europe':
          //Do nothing
          break

        case 'thumbnail':
          if (element.value[0].value) {
            imageUrl = element.value[0].value
          }
        case 'large_image':
        case 'thumbnail_image':
        case 'additional_images':
        case '_thumburl':
        case 'cad_configurable':
        case 'europe_total_sales':
        case 'fully_replaced':
        case 'fully_replaced_part':
        case 'norgrenelcstock':
        case 'partially_replaced':
        case 'partially_replaced_part':
        case 'replaced_flag':
        case 'restricted_item':
        case 'secondid':
        case 'cad_model':
        default:
          myOtherAttributes.push({
            name: findTranslation(element.name, displayFields),
            value: element.value[0].value,
          })
      }
    }

    setProductSlug(`/${navHome}/${navProduct}/${makePartNumberUrlSafe(myProductCode)}`)

    if (myCadenasCataloguePath && myVarSet) {
      let myCadLink = `https://norgren-embedded.partcommunity.com?info=imi_precision${myCadenasCataloguePath}&varset=${myVarSet}`

      if (myCadLink.indexOf('partFixed=') === -1) {
        myCadLink += '&partFixed=false'
      }

      setCadLink(myCadLink)
    }

    setOtherAttributes(myOtherAttributes)

    if (queryingUser === false) {
      if (isAnonymousUser(email) === true && country) {
        if (currency === null || currency === undefined) {
          setCurrency(GetCurrencyForCountry(country, countries))
        } else {
          getTheProduct(productCode, currency)
        }
      } else if (isAnonymousUser(email) === false) {
        getTheProduct(productCode, null)
      }
    } else {
      setLoading(true)
    }
  }, [item, productCode, queryingUser, email, country, currency, isRangeSKU])

  useEffect(() => {
    if (eventApi && eventModelToPublish) {
      publishProductClickEvent(eventApi, eventModelToPublish)
    }
  }, [eventApi, eventModelToPublish])

  const onProductClick = (e) => {
    e.preventDefault()

    try {
      let totalPrice = price ? parseFloat(price) : undefined

      setEventModelToPublish(
        buildProductClickEvent(
          {
            name: description ? description : undefined,
            series: undefined,
            sku: productCode,
            quantity: quantity,
            position: 0,
            brand: undefined,
            price: totalPrice,
            category: undefined,
          },
          basketCurrency,
          locale,
          accountNumber,
          isDistributor
        )
      )
    } catch (error) {
      logException('buildProductClickEvent error', error)
    }

    navigate(productSlug)
  }

  return (
    <div className="col grid-lister__item d-flex">
      <div className="grid-lister__details d-flex align-items-start flex-grow-1">
        <div className="grid-lister__image--listview-only">
          <img className="image__fit--cover no-opacity" src={imageUrl} alt={productCode} />
        </div>
        <div className="grid-lister__container d-flex flex-column flex-grow-1">
          <div className="grid-lister__details--description">
            <h4 className="mt-0">
              <a onClick={onProductClick} href={productSlug} rel="index,follow">
                {description !== null && description !== undefined ? description : null}
              </a>
            </h4>
          </div>
          <div className="grid-lister__details--stock d-flex flex-wrap mt-4 justify-content-between font__bold">
            <p>
              {getI18nText(productMicrocopy, 'product.productcode')}: {productCode}
            </p>
          </div>
          <div className="grid-lister__details--flipped">
            <div className="grid-lister__image">
              <img src={imageUrl} alt={productCode} className="image__fit--cover no-opacity" />
            </div>
            <div className="grid-lister__details--specs d-flex">
              <table>
                <tbody>
                  {otherAttributes.map((attribute, index) => {
                    if (index < 5) {
                      return (
                        <tr key={index}>
                          <th>{attribute.name}:</th>
                          <td>{attribute.value}</td>
                        </tr>
                      )
                    } else {
                      return null
                    }
                  })}
                </tbody>
              </table>
              {datasheetLink || cadLink ? (
                <table>
                  <tbody>
                    <tr>
                      <th>{getI18nText(productMicrocopy, 'product.downloads')}:</th>
                      <td>
                        <ul>
                          {cadLink ? (
                            <li>
                              <a
                                href={cadLink}
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex align-items-baseline"
                              >
                                <i className="icon-CAD"></i>
                                <p>{getI18nText(productMicrocopy, 'product.cad')}</p>
                              </a>
                            </li>
                          ) : null}
                          {datasheetLink ? (
                            <li>
                              <a
                                href={datasheetLink}
                                className="d-flex align-items-baseline"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <i className="icon-Technical-Specification"></i>
                                <p>{getI18nText(productMicrocopy, 'product.productdatasheet')}</p>
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : null}
            </div>
          </div>
          {isRangeSKU !== 'True' ? (
            <>
              <div className="grid-lister__details--pricing d-flex flex-wrap mt-2">
                <DisplayPrice
                  price={price}
                  currency={currency}
                  loginForPrice={loginForPrice}
                  locale={locale}
                  loading={loading}
                  quoteOnly={quoteOnly}
                />

                <div className="grid-lister__details--buttons d-flex align-items-center flex-wrap">
                  <a
                    onClick={onProductClick}
                    rel="index,follow"
                    className="btn btn-rebrand text-uppercase"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <span> {getI18nText(productMicrocopy, 'product.more')}</span>
                    </div>
                  </a>
                </div>
              </div>
              <DisplayDeliveryAndStock
                leadTime={leadTime}
                locale={locale}
                stockOnHand={stockOnHand}
                quantity={quantity}
                loading={loading}
                stockLevelIndicator={stockLevelIndicator}
              />
            </>
          ) : (
            <div className="grid-lister__details--pricing d-flex flex-wrap mt-2">
              <div className="grid-lister__details--buttons d-flex align-items-center flex-wrap">
                <a
                  onClick={onProductClick}
                  rel="index,follow"
                  className="btn btn-rebrand text-uppercase"
                >
                  <div className="d-flex justify-content-center align-items-center">
                    <span> {getI18nText(productMicrocopy, 'product.more')}</span>
                  </div>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const DisplayPrice = ({ price, currency, loginForPrice, locale, loading, quoteOnly }) => {
  const { accountType } = useContext(UserContext)
  const microcopy = useProductPriceI18n(locale)
  const [displayPrice, setDisplayPrice] = useState()

  useEffect(() => {
    const productPrice = price ? parseFloat(price).toFixed(2) : ''
    if (accountType === AccountTypeCredit) {
      if (productPrice !== '' && isNaN(productPrice) === false) {
        setDisplayPrice(DisplayPriceAsString({ currency: currency, amount: productPrice }))
      } else {
        if (quoteOnly) {
          setDisplayPrice(getI18nText(microcopy, 'productprice.requestquote'))
        } else {
          setDisplayPrice(getI18nText(microcopy, 'productprice.unavailable'))
        }
      }
    } else {
      if (quoteOnly) {
        setDisplayPrice(getI18nText(microcopy, 'productprice.requestquote'))
      } else {
        setDisplayPrice('')
      }
    }
  }, [price, currency, loginForPrice, accountType, quoteOnly])

  return (
    <>
      {loginForPrice === null || loginForPrice === undefined || loginForPrice === false ? (
        loading && accountType === AccountTypeCredit ? (
          <div className="grid-lister__details--cost flex-grow-1">
            <Spinner className="spinner spinner-inplace" animation="border" />
          </div>
        ) : displayPrice ? (
          <div className="grid-lister__details--cost flex-grow-1">
            <h4 className="font__bold mt-2 mb-3">{displayPrice}</h4>
          </div>
        ) : null
      ) : null}
    </>
  )
}

const DatasheetSearchResultItem = ({ item, displayFields }) => {
  const locale = useContext(LocaleContext)
  const productMicrocopy = useProductI18n(locale)

  const [imageUrl, setImageUrl] = useState()
  const [description, setDescription] = useState()
  const [productCode, setProductCode] = useState()
  const [datasheetLink, setDatasheetLink] = useState()

  useEffect(() => {
    for (let index = 0; index < item.attribute.length; index++) {
      const element = item.attribute[index]
      switch (element.name) {
        case '_imageurl':
          setImageUrl(element.value[0].value)
          break
        case 'documentlocation':
          setDatasheetLink(element.value[0].value)
          break
        case 'documentdescription':
          const myDescription = element.value[0].value
          if (myDescription) {
            import('he').then((he) => {
              if (myDescription) {
                setDescription(he.decode(myDescription))
              }
            })
          }
          break
        case 'documentname':
          break
        case 'productid':
          setProductCode(element.value[0].value)
          break
        default:
      }
    }
  }, [item])

  return (
    <div className="col grid-lister__item d-flex">
      <div className="grid-lister__details d-flex align-items-start flex-grow-1">
        <div className="grid-lister__image--listview-only">
          {imageUrl ? (
            <img className="image__fit--cover no-opacity" src={imageUrl} alt={productCode} />
          ) : null}
        </div>

        <div className="grid-lister__container d-flex flex-column flex-grow-1">
          <div className="grid-lister__details--description">
            <h4 className="mt-0">
              <a
                href={datasheetLink}
                className="d-flex align-items-baseline"
                target="_blank"
                rel="noreferrer"
              >
                {description}
              </a>
            </h4>
          </div>
          <div className="grid-lister__details--stock d-flex flex-wrap mt-4 justify-content-between font__bold">
            <p>
              {getI18nText(productMicrocopy, 'product.productcode')}: {productCode}
            </p>
          </div>
          <div className="grid-lister__details--flipped">
            <div className="grid-lister__image">
              {imageUrl ? (
                <img src={imageUrl} alt={productCode} className="image__fit--cover no-opacity" />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const DisplayDeliveryAndStock = ({
  locale,
  leadTime,
  quantity,
  stockOnHand,
  loading,
  stockLevelIndicator,
}) => {
  const microcopy = useProductPriceI18n(locale)
  const [estimatedDespatchDate, setEstimatedDespatchDate] = useState()
  const { country } = useContext(GeolocationContext)

  useEffect(() => {
    setEstimatedDespatchDate(calculateDaysToDespatch(leadTime, stockOnHand, quantity, country))
  }, [leadTime, quantity, stockOnHand])

  return (
    <div className="grid-lister__details--shipping mt-3">
      <>
        {loading ? (
          <Spinner className="spinner spinner-inplace" animation="border" />
        ) : (
          <p>
            <DisplayStock
              stockLevelIndicator={stockLevelIndicator}
              locale={locale}
              loading={loading}
            />
            {estimatedDespatchDate !== null && estimatedDespatchDate !== undefined ? (
              <span>
                {getI18nText(microcopy, 'productprice.estimatedshippingdate')}&nbsp;
                {estimatedDespatchDate}
              </span>
            ) : null}
          </p>
        )}
      </>
    </div>
  )
}

export const DisplayStock = ({ stockLevelIndicator, locale, loading }) => {
  const microcopy = useProductPriceI18n(locale)
  const stockMicrocopy = useProductStockI18n(locale)
  const [stock, setStock] = useState()

  useEffect(() => {
    const stockLevelText = getStockLevelString(stockLevelIndicator, stockMicrocopy)
    setStock(
      stockLevelText ? stockLevelText : getI18nText(microcopy, 'productprice.stockunavailable')
    )
  }, [stockLevelIndicator])

  function getStockResult(stock, stockLevelIndicator) {
    let content = StockLevel({ text: stock, stockLevelIndicator: stockLevelIndicator })

    if (stockLevelIndicator === 0) {
      content = <span></span>
    } else {
      content = StockLevel({ text: stock, stockLevelIndicator: stockLevelIndicator }) ?? (
        <span></span>
      )
    }

    return content
  }

  return (
    <>
      {loading ? (
        <Spinner className="spinner spinner-inplace" animation="border" />
      ) : (
        getStockResult(stock, stockLevelIndicator)
      )}
    </>
  )
}
